  // src/theme/palette.ts
  import { alpha } from "@mui/material/styles";

  // Greyscale tones for layout
  const GREY = {
    0: "#FFFFFF",
    100: "#F9F5FF",
    200: "#F4F0FF",
    300: "#E0D7F8",
    400: "#C9BEEA",
    500: "#B3A3D8",
    600: "#8E79B8",
    700: "#f3eff6",
    800: "#493A6D",
    900: "#2E2144",
  };

  // Primary: Mystic Violet
  const PRIMARY = {
    lighter: "#F4EFFF",
    light: "#BFA2F2",
    main: "#000000",
    dark: "#000000",
    // darker: "#4C1D95",
    contrastText: "#FFFFFF",
  };

  // Secondary: Arcane Rose
  const SECONDARY = {
    lighter: "#FFF0F6",
    light: "#F9A8D4",
    main: "#EC4899",
    dark: "#C02675",
    darker: "#9D174D",
    contrastText: "#FFFFFF",
  };

  // Info: Arcane Blue
  const INFO = {
    lighter: "#E0F2FE",
    light: "#7DD3FC",
    main: "#0EA5E9",
    dark: "#0369A1",
    darker: "#075985",
    contrastText: "#FFFFFF",
  };

  // Success: Mystic Green
  const SUCCESS = {
    lighter: "#DCFCE7",
    light: "#6EE7B7",
    main: "#10B981",
    dark: "#047857",
    darker: "#065F46",
    contrastText: GREY[900],
  };

  // Warning: Magical Amber
  const WARNING = {
    lighter: "#FEF3C7",
    light: "#FCD34D",
    main: "#F59E0B",
    dark: "#D97706",
    darker: "#92400E",
    contrastText: GREY[900],
  };

  // Error: Cursed Crimson
  const ERROR = {
    lighter: "#FEE2E2",
    light: "#FCA5A5",
    main: "#EF4444",
    dark: "#DC2626",
    darker: "#991B1B",
    contrastText: "#FFFFFF",
  };

  // Backgrounds: Light Fantasy
  const BACKGROUND = {
    navbar: "#fefacd",    // Changed to requested color
    sidebar: "#fefacd",   // Subtle lavender-gray
    default: "#f3eff6",   // Light neutral base.       card k piche ka color
    // card: "#FFFFFF",      // Crisp white for elevated card elements
    // paper: "#F3F0F9",     // Light pastel purple (soft container background)
  };
  
  


  // Text: Smooth and readable
  const TEXT = {
    primary: "#000000", // black
    secondary: "#000000", // black
    // contrast: "#8B5CF6", // For accents
    muted: "#6B7280", // For labels/placeholders
  };

  const palette = {
    common: { black: "#000000", white: "#fffad9" },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    background: BACKGROUND,
    text: TEXT,
    divider: alpha(GREY[500], 0.2),
    action: {
      active: GREY[700],
      hover: alpha(PRIMARY.main, 0.08),
      selected: alpha(PRIMARY.main, 0.16),
      disabled: alpha(GREY[500], 0.5),
      disabledBackground: alpha(GREY[300], 0.3),
      focus: alpha(PRIMARY.main, 0.12),
    },
  };

  export default palette;
